import api from '@/security/api'
import querystring from 'querystring'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const all = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/groups/all?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os grupos')
        })
}

const allByCompany = (id) => {
    return api.get(`/groups/bycompany/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os grupos')
        })
}

const findAll = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/groups?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de grupos')
        })
}

const find = (id) => {
    return api.get(`/groups/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar o grupo')
        })
}

const findAllSubgroups = (id) => {
    return api.get(`/groups/${id}/subgroups`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os subgrupos')
        })
}

const findAllContacts = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/groups/contacts?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os contatos')
        })
}

const destroyContacts = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.delete(`/groups/contacts?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível deletar o contato')
        })
}

const store = (data) => {
    return api.post('/groups', data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível salvar o grupo')
        })
}

const update = (data) => {
    return api.put(`/groups/${data.id}`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível atualizar o grupo')
        })
}

const destroy = (id) => {
    return api.delete(`/groups/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível excluir o grupo')
        })
}

export default {
    all,
    allByCompany,
    findAll,
    find,
    findAllSubgroups,
    findAllContacts,
    destroyContacts,
    store,
    update,
    destroy
}
